import React from 'react';
import {Link} from 'react-router-dom';
import {Card, FormFeedback, Button, FormGroup} from 'reactstrap';

import {FormSubmit} from 'components/Forms';
import {InputPassword} from 'components/Inputs';

import {REGEXP_FEEDBACK} from 'configs';
import useLoginPassword from './useLoginPassword';

function LoginPassword(props) {
  const {session, onNext, onPrev} = props;
  const {email, email_session_id} = session || {};

  const {isLoading, loginPassword} = useLoginPassword(onNext);

  return (
    <React.Fragment>
      <div className="text-center">
        <h1>Welcome</h1>

        <Card className="d-inline-block py-1 px-3 mb-2 notranslate">
          {email}
        </Card>
        <p>
          Not you?{' '}
          <span
            style={{cursor: 'pointer'}}
            className="btn-link d-inline"
            onClick={() => onPrev()}
          >
            Use another account
          </span>
        </p>
      </div>

      <FormSubmit
        onSubmit={(formData) => loginPassword({email_session_id, ...formData})}
        isSubmitting={isLoading}
      >
        <fieldset disabled={isLoading}>
          <FormGroup>
            <InputPassword
              name="password"
              label="To continue, first verify it's you"
              placeholder="Enter your password"
              disabled={isLoading}
              pattern={null}
              required
            >
              <FormFeedback>{REGEXP_FEEDBACK.required}</FormFeedback>
            </InputPassword>
          </FormGroup>

          <Button type="submit" disabled={isLoading} color="primary" block>
            {isLoading ? 'Submitting...' : 'Next'}
          </Button>
        </fieldset>
      </FormSubmit>

      <div className="mt-4 text-center">
        <Link to="/forgot/password">Forgot Password</Link>
      </div>
    </React.Fragment>
  );
}

export default LoginPassword;
